import React from "react";
import crane from "../../assets/construction.png";
import check from "../../assets/packages/check.png";

export default function Packages() {
  const plans = [
    {
      id: 1,
      title: "Startup",
      price: "₹12,999",
      note: "EXCLUSIVE OF ALL TAXES",
      features: [
        "Upto 5 Pages",
        "Logo",
        "Slider",
        "Dynamic Website",
        "1 Email – 500 MB Quota",
        "1 Contact Form",
        "Free SSL",
        "Testimonials",
        "Gallery Section",
        "Chat Feature",
        "Content - 1 Rs per word",
        "Social Profile Link",
        "Click to Call/Email",
        "Mobile Responsive",
        "Login Details Will Be Given",
        "Delivery in 7 Days",
        "Free 1 Month Support",
      ],
    },
    {
      id: 2,
      title: "Small Business",
      price: "₹19,999",
      note: "EXCLUSIVE OF ALL TAXES",
      features: [
        "10 Pages",
        "Logo",
        "Slider",
        "Dynamic Website",
        "1 Email – 500 MB Quota",
        "1 Contact Form",
        "Free SSL",
        "Testimonials",
        "Gallery Section",
        "Chat Feature",
        "Content - 1 Rs per word",
        "Social Profile Link",
        "Click to Call/Email",
        "Mobile Responsive",
        "Login Details Will Be Given",
        "Delivery in 14 Days",
        "Free 1 Month Support",
      ],
    },
    {
      id: 3,
      title: "eCommerce",
      price: "₹29,999",
      note: "EXCLUSIVE OF ALL TAXES",
      features: [
        "Up to 50 Products",
        "Logo",
        "Contact Form – 3",
        "Content - 1 Rs per word",
        "WhatsApp Chat Integration",
        "Social Media Profiles Integration",
        "Social Profile Link",
        "Shopify Login Details Will be Given",
        "Payment Gateway",
        "Extra Support – 500 Rs/Hour",
        "Revisions – 2",
        "Free 1 Month Support",
      ],
    },
    {
      id: 4,
      title: "Custom",
      price: "Custom Quote",
      note: "EXCLUSIVE OF ALL TAXES",
      features: ["Depends on Requirement"],
    },
  ];

  const handleEvent = (plan) => {
    const message = `I am interested in the ${
      plan.title
    } package.

Price: ${plan.price}

Features:
${plan.features.map((f, i) => `${i + 1}. ${f}`).join("\n")}`;

    const url = `https://wa.me/918700364602?text=${encodeURIComponent(
      message
    )}`;

    window.open(url, "_blank");
  };

  return (
    <div
      className="container servicesContent"
      style={{
        paddingTop: "60px",
        paddingBottom: "60px",
      }}
    >
      <p
        style={{
          color: "#090909",
          fontSize: "18px",
          marginBottom: "10px",
        }}
      >
        Packages
      </p>

      <div className="d-flex align-items-center flex-wrap mb-3">
        <h2
          style={{
            color: "#3e13c0",
            fontWeight: "500",
            fontFamily: "Bungee, sans-serif",
            marginBottom: "0",
          }}
        >
          Lift Up Your Business
        </h2>

        <img
          src={crane}
          alt="crane"
          className="ms-3"
          style={{
            width: "35px",
            height: "35px",
          }}
        />
      </div>

      <div className="row mt-5">
        {plans.map((plan) => (
          <div
            className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4"
            key={plan.id}
          >
            <div
              className="card h-100"
              style={{
                borderRadius: "20px",
                border: "1px solid #ececec",
                boxShadow: "0 8px 25px rgba(62, 19, 192, 0.10)",
                transition: "all 0.3s ease",
              }}
            >
              <div className="card-body d-flex flex-column">
                {/* Header */}
                <div>
                  <h4
                    className="text-center mb-3"
                    style={{
                      color: "#3e13c0",
                      fontFamily: "Bungee, sans-serif",
                      fontSize: "22px",
                    }}
                  >
                    {plan.title}
                  </h4>

                  <hr />

                  <h2
                    className="text-center"
                    style={{
                      fontWeight: "700",
                      color: "#000",
                    }}
                  >
                    {plan.price}
                  </h2>

                  <p
                    className="text-center text-muted"
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    {plan.note}
                  </p>

                  <ul className="list-unstyled mt-4">
                    {plan.features.map((feature, i) => (
                      <li
                        key={i}
                        className="d-flex align-items-start mb-3"
                      >
                        <img
                          src={check}
                          alt="check"
                          width="18"
                          height="18"
                          className="me-2 mt-1"
                        />

                        <span
                          style={{
                            fontSize: "14px",
                            color: "#333",
                          }}
                        >
                          {feature}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Button fixed bottom */}
                <div className="mt-auto pt-3">
                  <button
                    className="btn w-100"
                    style={{
                      backgroundColor: "#3e13c0",
                      color: "#fff",
                      borderRadius: "12px",
                      padding: "12px",
                      fontWeight: "500",
                      border: "none",
                    }}
                    onClick={() => handleEvent(plan)}
                  >
                    Select Package
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Custom Styling */}
      <style>
        {`
          .card:hover {
            transform: translateY(-8px);
          }

          @media (max-width: 768px) {
            .servicesContent {
              padding-left: 15px !important;
              padding-right: 15px !important;
            }

            h2 {
              font-size: 28px !important;
            }
          }
        `}
      </style>
    </div>
  );
}